import { useEffect, useState } from "react";
import type React from "react";
import axios from "axios";
import logo from "../../assets/logo.svg";
import { Link, useParams } from "react-router-dom";

const ResetPassword: React.FC = () => {
  const { token } = useParams();
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [formErrors, setFormErrors] = useState({
    password: "",
    confirmPassword: "",
  });


  useEffect(() => {
    if (formData.confirmPassword && formData.confirmPassword !== formData.password)

      setFormErrors(prev => ({
        ...prev,
        confirmPassword: "Password do not match"
      }));
    else {
      setFormErrors(prev => ({
        ...prev,
        confirmPassword: ""
      }));
    }

  }, [formData])


  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (Object.values(formErrors).some(error => error)) {
      const firstErrorField = Object.keys(formErrors).find(
        key => formErrors[key as keyof typeof formErrors]
      );

      const errorElement = document.getElementById(firstErrorField!);
      errorElement?.scrollIntoView({ behavior: "smooth", block: "center" });
      errorElement?.focus();
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.request(
        {
          baseURL: `${window.env.API_URL}/api/v1/auth/reset-password`,

          timeout: 10000,
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
          data: {
            password: formData.password
          },
          params: {
            token: token
          }
        }
      );

      if (response.status === 200) {
        setSuccess(true);
      }
    } catch (error: any) {
      setError(error.response?.data?.message || "Error resetting password");
    } finally {
      setLoading(false);
    }
  };

  function validatePassword(password: string) {
    if (password.length < 8) {
      return "Password must be at least 8 characters long.";
    }

    if (!/[A-Z]/.test(password)) {
      return "Password must contain at least one uppercase letter.";
    }

    if (!/[0-9]/.test(password)) {
      return "Password must contain at least one number.";
    }

    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      return "Password must contain at least one special character.";
    }

  }

  return (
    <div className="login-page">

      <img src={logo} alt="Fincentive Logo" className="logo" />

      <div className="login-container">
        {!loading && <h2>Reset Password</h2>}

        {/* Show loading spinner in the center */}
        {loading && (
          <div>
            <div className="spinner"></div> {/* Add CSS for the spinner */}
          </div>
        )}


        {!loading && (
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label className="border-label">Password</label>
              <input
                type="text"
                value={formData.password}
                onChange={(e) => {
                  {
                    const { id, value } = e.target;
                    const error = validatePassword(value)
                    if (error) {
                      setFormErrors(prev => ({
                        ...prev,
                        [id]: error
                      }));
                    }
                    else {
                      setFormErrors(prev => ({
                        ...prev,
                        [id]: ""
                      }))
                    }
                    setFormData(prev => ({
                      ...prev,
                      [id]: value
                    }));




                  };

                }}
                placeholder="Enter Password"
                className={formErrors.password ? "is-invalid" : ""}
              />
              {formErrors.password && (
                <div className="invalid-feedback">
                  {formErrors.password}
                </div>
              )}
            </div>
            <div className="input-group">
              <label className="border-label">Confirm Password</label>
              <input
                type="password"
                value={formData.confirmPassword}
                onChange={(e) => {
                  const { id, value } = e.target;

                  setFormData(prev => ({
                    ...prev,
                    [id]: value
                  }));

                }}
                placeholder="Re-Enter Password"
                className={formErrors.confirmPassword ? "is-invalid" : ""}
              />
              {formErrors.confirmPassword && (
                <div className="invalid-feedback">
                  {formErrors.confirmPassword}
                </div>
              )}
            </div>
            <button type="submit" className="login-button">
              Reset
            </button>
          </form>

        )}

        {/* Show error message as bottom popup */}
        {error && <div className="error-popup">Invalid Credentials</div>}
        {success && <div className="success-popup">Password Reset, <a href="/">Go to Login?</a></div>}
      </div>
    </div>
  );
};

export default ResetPassword;